<template>
  <div class="BrandPage relative">
    <div v-editable="blok" class="w-full overflow-hidden pb-56 desk:pb-64">
      <div class="topMarginReference" />
      <div
        v-if="userStore.isSalesRepUser"
        class="pb-12 bg-lightest shadow-bottomLine mb-40 !mt-12 select-none"
      >
        <div class="layout-container flex flex-row gap-x-12 items-center justify-between desk:justify-start">
          <div class="type-headline-xs leading-single" @click="hideBrandContent = !hideBrandContent">{{ $t('productList.hide.content') }}</div>
          <TouchCheckbox :selected="hideBrandContent" @set="payload => hideBrandContent = payload" />
        </div>
      </div>

      <AutoBreadcrumbs v-if="!blok.hideBreadcrumbs && !hideBrandContent" />
      <div
        v-if="blok.brandLogo && blok.brandLogo.filename && !hideBrandContent"
        class="text-center"
        :class="[desktopWidth('full')]"
      >
        <img
          :src="blok.brandLogo.filename"
          class="inline-block w-full h-full max-h-96 max-w-208 mb-12 desk:mb-24"
          :alt="blok.brandLogo.alt"
        >
      </div>
      <SpaceHandler
        v-for="(childBlok, index) in filteredBody"
        :key="childBlok._uid"
        :blok="childBlok"
      >
        <ProductList
          v-if="childBlok.component === 'ProductList'"
          :key="childBlok._uid + hideBrandContent"
          :blok="childBlok"
          :placement="index"
          :is-brand-page="true"
          :brand="blok.brand"
        />
        <StoryblokComponent
          v-else
          :blok="childBlok"
          :placement="index"
        />
      </SpaceHandler>
    </div>
  </div>
</template>

<script setup lang="ts">
import {
  SingleSelectBrandAlgolia,
  StoryBlokAsset,
  StoryBlokPropBase,
  StoryBlokSeoPlugin
} from '~/constants/types/storyblok';
import { SbBlokData } from '@storyblok/vue';
import SpaceHandler from '~/components/body/SpaceHandler.vue';
import ProductList from '~/components/product/ProductList.vue';
import useSeoCreator from '~/composeables/useSeoCreator';
import AutoBreadcrumbs from '~/components/body/AutoBreadcrumbs.vue';
import useDesktopWidth from '~/composeables/useDesktopWidth';
import TouchCheckbox from '~/components/form-elements/TouchCheckbox.vue';
import { useUserStore } from '~/store/user';
const userStore = useUserStore();

const hideBrandContent = useCookie<boolean>('hideBrandContent', { maxAge: 3600 * 24 * 182, path: '/', default: () => false });

export type StoryBlokBrandPageContent = StoryBlokPropBase<'BrandPage'> & {
  body: SbBlokData[],
  brand: SingleSelectBrandAlgolia;
  brandCategory: string;
  brandFlag: string;
  brandLogo?: StoryBlokAsset;
  hideBreadcrumbs: boolean;
  seo: StoryBlokSeoPlugin;
  showInAutomaticList: boolean;
}

const props = defineProps<{
  blok: StoryBlokBrandPageContent,
}>();

const { desktopWidth } = useDesktopWidth(props);

if (props.blok.seo) {
  useSeoCreator().createMeta(props.blok.seo);
}

const filteredBody = computed(()=> {
  if (hideBrandContent.value) {
    const firstProductList = props.blok.body.findIndex(f => f.component === 'ProductList');
    if (firstProductList > -1) {
      return props.blok.body.toSpliced(0, firstProductList);
    }
  }
  return props.blok.body;
});

</script>

<style lang="postcss">

</style>
